import Webcam from "react-webcam";
import { BsFillCameraFill } from "react-icons/bs";
import { Button, Box } from "@chakra-ui/react";
import { forwardRef } from "react";

const WebcamInput = ({ webCamOpen, closeWebCam, capture, webCam }, ref) => {
  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 999,
      }}
    >
      <Webcam
        audio={false}
        height={600}
        ref={ref}
        screenshotFormat="image/jpeg"
        width={1200}
        videoConstraints={{
          width: 1280,
          height: 720,
          facingMode: "user",
        }}
      />

      {webCamOpen && (
        <>
          <Button
            onClick={closeWebCam}
            bg="red"
            _hover={{ filter: "brightness(0.9)" }}
            transition="filter 0.2s"
            color="white"
            position="absolute"
            top="1rem"
            right="1rem"
          >
            Sair
          </Button>
          <div
            style={{
              position: "absolute",
              bottom: "0",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Box
              align="center"
              gap={2}
              onClick={capture}
              cursor="pointer"
              p={2}
              bg="#378BBF"
              borderRadius="md"
            >
              <BsFillCameraFill size={30} color="white" />
            </Box>
          </div>
        </>
      )}
    </div>
  );
};

export default forwardRef(WebcamInput);
